@let msg = message();
<div class="d-flex mb-2" [ngClass]="(msg | isHuman) ? 'justify-content-end' : 'justify-content-start'">
  <div class="ai-bubble px-2 py-2 border" [ngClass]="(msg | isHuman) ? 'ai-bubble--user chat-bubble-user' : 'ai-bubble--ai chat-bubble-ai'">
    <div class="small bubble-text">
      @if(text(); as txt) {
        <app-style-boundary>
          <markdown>{{ txt }}</markdown>
        </app-style-boundary>
      }
      <app-chat-message-artifact [message]="msg"/>

      @if (isCrashed()) {
        <button class="retry-btn chat-retry btn btn-sm btn-outline-secondary mt-2" (click)="retryClicked.emit()">Prøv igjen</button>
      }

      @for (call of toolCalls(); track call.id) {
        <div class="mt-2 border rounded p-2 bg-light text-dark">
          <div class="d-flex align-items-center">
            <i class="fas fa-wrench mr-2"></i>
            <span class="font-weight-bold text-capitalize">{{ call.label }}</span>
          </div>
        </div>
      }

    </div>
    <div class="text-muted bubble-timestamp mt-1">{{ createdAt() | relativeTime }}</div>
  </div>
</div>
